import { useState } from 'react';
import { gapi } from 'gapi-script';
import { auth } from '../firebase'; // Firebase authentication

const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
const DISCOVERY_DOCS = [process.env.REACT_APP_GOOGLE_DISCOVERY_DOCS];
const SCOPES = process.env.REACT_APP_GOOGLE_SCOPES;

export const useGoogleCalendar = () => {
  const [isSignedIn, setIsSignedIn] = useState(false);

  // Função para inicializar o Google API
  const initClient = async (googleAccessToken) => {
    try {
      if (!googleAccessToken) {
        console.error('Erro: O token de acesso do Google não foi encontrado.');
        return;
      }

      gapi.load('client', () => {
        gapi.client
          .init({
            apiKey: API_KEY,
            clientId: CLIENT_ID,
            discoveryDocs: DISCOVERY_DOCS,
            scope: SCOPES,
          })
          .then(() => {
            gapi.client.setToken({ access_token: googleAccessToken });
            setIsSignedIn(true);
          })
          .catch((error) => {
            console.error('Erro ao inicializar o Google API:', error);
          });
      });
    } catch (error) {
      console.error('Erro ao inicializar o Google API:', error);
    }
  };

  // Função para criar um evento no Google Calendar
  const createEvent = async (eventDetails) => {
    try {
      const request = {
        summary: eventDetails.title,
        description: eventDetails.description,
        start: {
          dateTime: eventDetails.startDateTime,
          timeZone: 'America/Sao_Paulo',
        },
        end: {
          dateTime: eventDetails.endDateTime,
          timeZone: 'America/Sao_Paulo',
        },
        attendees: eventDetails.attendees || [],
        reminders: {
          useDefault: true,
        },
      };

      const response = await gapi.client.calendar.events.insert({
        calendarId: 'primary',
        resource: request,
      });

      return response.result;
    } catch (error) {
      console.error('Erro ao criar evento no Google Calendar:', error);
      throw new Error('Falha ao criar evento.');
    }
  };

  return {
    isSignedIn,
    initClient,
    createEvent,
  };
};
